import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
import { COMPONENT_MARGIN_BOTTOM, NAV_HEADER_HT } from '../../constants';
const Container = styled.div `
  margin-top: ${`${NAV_HEADER_HT.DESKTOP}px`};
  width: 100%;

  ${media.tablet} {
    margin-top: ${`${NAV_HEADER_HT.TABLET}px`};
  }
`;
const SampleContainer = styled.div `
  background: lightgray;
  height: 1000px;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: gray;

  margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.DESKTOP}px`};

  ${media.mobile} {
    margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.MOBILE}px`};
  }
`;
const MockNavHeader = styled.header `
  position: fixed;
  top: 0;
  left: 0;
  height: ${`${NAV_HEADER_HT.DESKTOP}px`};
  width: 100%;
  background-color: lightgoldenrodyellow;
  color: gray;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;

  ${media.tablet} {
    height: ${`${NAV_HEADER_HT.TABLET}px`};
  }
`;
export const StoryWrapper = ({ withTop, withBottom, children }) => {
    return (React.createElement(Container, null,
        React.createElement(MockNavHeader, null,
            React.createElement("h1", null, "Sample Header")),
        withTop && (React.createElement(React.Fragment, null,
            React.createElement(SampleContainer, null,
                React.createElement("h1", null, "Sample Container")))),
        children,
        withBottom && (React.createElement(SampleContainer, null,
            React.createElement("h1", null, "Sample Container")))));
};
